import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from 'src/app/services/master.service';
import { ContactRequest } from 'src/app/models/contact.model';
import * as moment from 'moment';

@Component({
  selector: 'app-add-requirement-reclaim',
  templateUrl: './add-requirement-reclaim.component.html',
  styleUrls: ['./add-requirement-reclaim.component.scss']
})
export class AddRequirementsReclaimComponent implements OnInit {
  public selectedIndex: number = 0;
  registerForm: FormGroup;
  contactReq = [];
  contactRec = [];
  invalidForm = true;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private masterService: MasterService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getListContact();
  }

  private createForm(): any {
    this.registerForm = this.formBuilder.group({
      userDetailReq: this.formBuilder.group({
        registerType: [''],
        document: [''],
        name: [''],
        lastname: [''],
        secondname: [''],
        email: [''],
        phone: [''],
        depart: ['',],
        provin: ['',],
        district: ['',],
        direction: [''],
      }),
      userDetailRec: this.formBuilder.group({
        registerType: ['',],
        document: [''],
        name: [''],
        lastname: [''],
        secondname: ['',],
        email: [''],
        phone: [''],
        depart: ['',],
        provin: ['',],
        district: ['',],
        direction: [''],
      }),
      requirementDetail: this.formBuilder.group({
        detail: [''],
        contact: new FormArray([])
      }),
      reclaimDetail: this.formBuilder.group({
        themeId: [null],
        sureId: [null],
        licensePlate: [''],
        date: [null],
        time: [null],
        detail: [''],
        request: [''],
        contact: ['']
      })
    });

    this.onTabChanged({ index: 0 });
  }

  onNoClick(): void { this.activeModal.close(); }
  responseValidatingReq(value) { this.invalidForm = value; }

  getListContact(): void {
    this.masterService.getList(7, 0).subscribe(
      (response: any) => {
        this.contactReq = response;
        this.updateFormRequirement();
      }
    );
    this.masterService.getList(6, 0).subscribe(
      (response: any) => {
        this.contactRec = response;
      }
    );
  }

  updateFormRequirement() {
    let contact = this.registerForm.controls.requirementDetail.get('contact') as FormArray;
    for (let i = 0; i < this.contactReq.length; i++) {
      contact.push(new FormControl(false));
    }
  }

  send() {
    let dataUserDetail = this.selectedIndex == 0 ? this.registerForm.value.userDetailReq : this.registerForm.value.userDetailRec;
    let dataRequirementDetail = this.registerForm.value.requirementDetail;
    let dataReclaimDetail = this.registerForm.value.reclaimDetail;
    let formrray = [];

    if ((this.selectedIndex == 0 && this.registerForm.controls.requirementDetail.valid) || (this.selectedIndex == 1 && this.registerForm.controls.reclaimDetail.valid)) {

      if (this.selectedIndex == 0) {
        if (this.registerForm.controls.requirementDetail.invalid) { return false; }

        for (let i = 0; i < dataRequirementDetail.contact.length; i++) {
          if (dataRequirementDetail.contact[i] === true) {
            formrray = formrray.concat({ ContacWayId: this.contactReq[i].id });
          }
        }
      } else if (this.selectedIndex == 1) {
        if (this.registerForm.controls.reclaimDetail.invalid) { return false; }
        formrray = formrray.concat({ ContacWayId: dataReclaimDetail.contact.id });
      }

      let odata = new ContactRequest();
      odata.RegisterType = dataUserDetail.registerType;
      odata.Document = dataUserDetail.document;
      odata.Name = dataUserDetail.name;
      odata.SecondName = dataUserDetail.secondname;
      odata.LastName = dataUserDetail.lastname;
      odata.Email = dataUserDetail.email;
      odata.Phone = dataUserDetail.phone;
      odata.Address = dataUserDetail.direction;
      odata.District = dataUserDetail.district;

      // Requirements
      odata.Detail = this.selectedIndex == 0 ? dataRequirementDetail.detail : dataReclaimDetail.detail;
      odata.ContacWay = formrray;

      odata.Request = this.selectedIndex == 0 ? '' : dataReclaimDetail.request;
      odata.SureId = this.selectedIndex == 0 ? null : dataReclaimDetail.sureId;
      odata.ThemeId = this.selectedIndex == 0 ? null : dataReclaimDetail.themeId;
      odata.Date = this.selectedIndex == 0 ? null : moment(dataReclaimDetail.date).format('YYYY-MM-DD') + 'T' + (dataReclaimDetail.sureId !== 3 ? dataReclaimDetail.time : '00:00') + ':00.000Z';
      odata.LicensePlate = this.selectedIndex == 0 ? '' : (dataReclaimDetail.sureId === 3 ? dataReclaimDetail.licensePlate : '');

      odata.TypeId = this.selectedIndex == 0 ? 2 : 1; // => REQ = 2, REC = 1;
      odata.TypeClientId = 0; // es o no cliente
      odata.DateRegister = moment(new Date()).format('YYYY-MM-DD') + 'T' + (this.formatHours('hours')) + ':' + (this.formatHours('minutes')) + ':00.000Z';

      this.activeModal.close(odata);
    } else {
      dataUserDetail.markAllAsTouched();
      if (this.selectedIndex == 0) {
        dataRequirementDetail.markAllAsTouched();
      } else if (this.selectedIndex == 1) {
        dataReclaimDetail.markAllAsTouched();
      }
    }
  }

  // Required Fields
  onTabChanged(tab) {
    let index = tab.index;
    this.selectedIndex = index;
    // ****     userDetailReq     ****
    let urlControlReq = this.registerForm.controls.userDetailReq.get('registerType');
    index === 0 ? urlControlReq.setValidators([Validators.required]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('document');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(8)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('name');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('lastname');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    // SecondName X
    urlControlReq = this.registerForm.controls.userDetailReq.get('email');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1), Validators.email, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('phone');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(9)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('depart');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('provin');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('district');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailReq.get('direction');
    index === 0 ? urlControlReq.setValidators([Validators.required, Validators.minLength(1)]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();
    // =>   requirementDetail
    urlControlReq = this.registerForm.controls.requirementDetail.get('detail');
    index === 0 ? urlControlReq.setValidators([Validators.required]) : urlControlReq.clearValidators(); urlControlReq.updateValueAndValidity();


    // ****     userDetailRec     ****
    let urlControlRec = this.registerForm.controls.userDetailRec.get('registerType');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('document');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(8)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('name');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('lastname');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    // SecondName X
    urlControlRec = this.registerForm.controls.userDetailRec.get('email');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1), Validators.email, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('phone');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(9)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlReq = this.registerForm.controls.userDetailRec.get('depart');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('provin');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('district');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.userDetailRec.get('direction');
    index === 1 ? urlControlRec.setValidators([Validators.required, Validators.minLength(1)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();

    // =>     reclaimDetail
    urlControlRec = this.registerForm.controls.reclaimDetail.get('themeId');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.reclaimDetail.get('sureId');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    // licensePlate
    urlControlRec = this.registerForm.controls.reclaimDetail.get('date');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    // time
    urlControlRec = this.registerForm.controls.reclaimDetail.get('detail');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.reclaimDetail.get('request');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
    urlControlRec = this.registerForm.controls.reclaimDetail.get('contact');
    index === 1 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();
  }

  //#region [Util]
  formatHours(timeType: string): any {
    const date = timeType === 'minutes' ? new Date().getMinutes() : new Date().getHours();
    const resultDate = date < 10 ? '0' + date.toString() : date;
    return resultDate;
  }
  //#endregion

}
